import { Injectable, inject } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { DataSecurityService } from '../data-security.service';

@Injectable({
    providedIn: 'root',
})
export class IdleService {
    private readonly _dataSecurityService = inject(DataSecurityService);

    private readonly activity: ReplaySubject<number>;
    private readonly _setNextActivity = () => {
        this.activity.next(parseInt(this.getLastActivity()));
    };
    private readonly itemName: string;

    constructor() {
        this.itemName = 'onboard-service';
        this.activity = new ReplaySubject(1);
    }

    /**
     * @method getLastActivity
     * @description Return the last time of activity
     */

    getLastActivity(): string {
        let lastActivity = localStorage.getItem(this.itemName);
        if (lastActivity) {
            lastActivity = this._dataSecurityService.decryptString(lastActivity);
        }
        return lastActivity ?? String(new Date().getTime());
    }

    /**
     * @method removeListener
     * @description Remove the last user activity
     */

    removeListener(): void {
        window.removeEventListener('storage', this._setNextActivity);
    }

    /**
     * @method initListener
     * @description
     */

    initListener(): void {
        this.removeListener();
        window.addEventListener('storage', this._setNextActivity);
    }

    /**
     * @method setActivity()
     * @description Save the user activity
     */

    setActivity(): void {
        localStorage.setItem(this.itemName, this._dataSecurityService.encrypt(String(new Date().getTime())));
        this._setNextActivity();
    }
}
